import React from 'react';
import Typography from '@material-ui/core/Typography';

export default props => (
  <Typography {...props} className="atmslogo">
    <span className="ascend-orange">Ascend</span>
    <span className="ascend-blue">Portal</span>
  </Typography>
);
